import { memoize, range } from "./_common";
import { OffsetPoint } from "./OffsetPoint";
export const POLYGON_RADIUS = 100;
export var Shape;
(function (Shape) {
    const getAngleFromSideCount = (sides) => (2 * Math.PI / sides);
    // Plots a regular polygon, which has angles in equal measure (direct equiangular) and sides in equal measure (equilateral). It
    // can scale arbitrarily with sides >= 3
    // https://en.wikipedia.org/wiki/Regular_polygon
    Shape.getRegularPolygonContour = (sides, radius, { x, y }) => {
        if (sides < 3)
            throw new Error('IllegalArgument');
        const sideAngle = getAngleFromSideCount(sides);
        return range(sides).map((sideIdx) => [
            x + radius * Math.cos(sideAngle * sideIdx),
            y + radius * Math.sin(sideAngle * sideIdx),
        ]);
    };
    Shape.getHexContour = memoize((point) => OffsetPoint.toCacheKey(point), (point) => Shape.getRegularPolygonContour(6, POLYGON_RADIUS, OffsetPoint.toPixelPoint(point)));
})(Shape || (Shape = {}));
//# sourceMappingURL=Shape.js.map